<template>
    <div>
        <v-card>
            <v-card-text>
                <strong>NEW SUBSCRIPTION DETAILS</strong>
            </v-card-text>
            <v-divider></v-divider>
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Event Code" outlined placeholder="john-doe-at-60" dense hide-details 
                            v-model="subscription.event_code">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Hash Tag" outlined placeholder="#JohnDoeAt60" dense hide-details 
                            v-model="subscription.hash_tag">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Start Date" outlined dense hide-details 
                            v-model="subscription.start_date"
                            append-icon="mdi-calendar"
                            readonly
                            @click:append="openDatePicker('start_date')">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="End Date" outlined dense hide-details 
                            v-model="subscription.end_date"
                            append-icon="mdi-calendar"
                            readonly
                            @click:append="openDatePicker('end_date')">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Theme" outlined dense hide-details readonly
                            v-model="subscription.theme"
                            append-icon="mdi-select-color"
                            @click:append="openColorPicker()">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-file-input label="Logo" outlined dense hide-details append-icon="mdi-image"
                            v-model="subscription.logo">
                        </v-file-input>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-file-input label="Banner (1280x715 pixels)" outlined dense hide-details append-icon="mdi-image"
                            v-model="subscription.banner">
                        </v-file-input>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-file-input label="Background (2400x1350 pixels)" outlined dense hide-details append-icon="mdi-image"
                            v-model="subscription.background">
                        </v-file-input>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field label="Rotation Control Duration (Minutes)" outlined dense hide-details 
                            v-model="subscription.rotation_interval"
                            type="number"
                            placeholder="3">
                        </v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-checkbox dense hide-details v-model="subscription.enable_message_approval" value="1" label="With Message Screening"></v-checkbox>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-checkbox dense hide-details v-model="subscription.show_timestamp" value="1" label="Show Timestamp"></v-checkbox>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-checkbox dense hide-details v-model="subscription.require_email" value="1" label="Require Email"></v-checkbox>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-checkbox dense hide-details v-model="subscription.require_mobile" value="1" label="Require Mobile Number"></v-checkbox>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn small color="primary" block @click="submit()">Submit</v-btn>
            </v-card-actions>
        </v-card>
        <v-dialog width="280" v-model="datepicker_dialog">
            <v-card>
                <v-date-picker v-model="datepicker"></v-date-picker>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small @click="setDate()">Set Date</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog width="250" v-model="colorpicker_dialog">
            <v-card>
                <v-color-picker
                    dot-size="25"
                    swatches-max-height="200"
                    mode="hexa"
                    v-model="colorpicker"
                ></v-color-picker>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small @click="setColor()">Set Theme Color</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    name : 'SubscriptionDialog',
    data() {
        return {
            subscriptions : [],
            subscription : {},
            picker_selection : null,
            datepicker_dialog : false,
            colorpicker_dialog : false,
            colorpicker : null,
            datepicker : new Date()
        }
    },
    methods: {
        openColorPicker() {
            this.colorpicker = this.subscription.theme ? this.subscription.theme : '#fff';
            this.colorpicker_dialog = true;
        },
        setColor() {
            this.subscription.theme = this.colorpicker;
            this.colorpicker_dialog = false;
        },
        openDatePicker(type) {
            this.picker_selection = type;
            if(type == 'start_date') {
                this.datepicker = this.subscription.start_date ? this.subscription.start_date : null;
                this.datepicker_dialog = true;
            }
            else {
                this.datepicker = this.subscription.end_date ? this.subscription.end_date : null;
                this.datepicker_dialog = true; 
            }
        },
        setDate() {
            if(this.picker_selection == 'start_date') {
                this.subscription.start_date = this.datepicker;
            }

            else {
                this.subscription.end_date = this.datepicker;
            }

            this.datepicker_dialog = false;
        },
        submit() {
            let formData = new FormData();
            formData.append('event_code', this.subscription.event_code || '');
            formData.append('hash_tag', this.subscription.hash_tag || '');
            formData.append('start_date', this.subscription.start_date || '');
            formData.append('end_date', this.subscription.end_date || '');
            formData.append('theme', this.subscription.theme || '');
            formData.append('banner', this.subscription.banner || '');
            formData.append('background', this.subscription.background || '');
            formData.append('logo', this.subscription.logo || '');
            formData.append('enable_message_approval', this.subscription.enable_message_approval || 0);
            formData.append('require_email', this.subscription.require_email || 0);
            formData.append('require_mobile', this.subscription.require_mobile || 0);
            formData.append('rotation_interval', this.subscription.rotation_interval || 3);

            this.$store.commit('setLoading', true);

            axios({
                url : this.$store.state.api_url + '/subscriptions',
                method : 'POST',
                data : formData,
                headers : {
                    'Content-Type' : 'application/x-www-form-urlencoded',
                    'Authorization' : 'Bearer ' + this.$store.state.user.token
                }
            }).then(res => {
                this.$emit('refresh');
                this.$emit('close');
            })
        }
    }
}
</script>